<template>
    <div class="tablenav-pages" v-if="paignation.length>1">
        <div class="pagination" >
            <a class="prev" @click="pagechange">Previous Page</a>
            <template v-for="(item,index) in paignation" >
            <span class="current" v-if="item.active" :key='index'>{{item.name}}</span>
            <a @click="pagechange" v-else :key='index'>{{item.name}}</a>
            </template>
            <a class="next" @click="pagechange">Next Page</a>
        </div>
    </div>
</template>
<script>
export default {
  data(){
    return {
      page:{
        pageNo:this.pageNo,
        total:this.total
      }
    }
  },
  props:{
      pageNo:{
          default:0,
          required:true
      },
      total:{
          default:0,
          required:true
      },
      pageSize:{
        default:10
      }
  },
  mounted() {
  
  },
  watch: {
    pageNo(newValue){
      this.page.pageNo = newValue
    },
    total(newValue){
      this.page.total = newValue
    }
  },
  computed: {
    paignation(){
      let page = [];
      let total = Math.ceil(this.page.total/this.pageSize);
      // let total = 9;
      let pageNo = this.page.pageNo+1;
      if(total>7){
        let left = [];
        if(pageNo<5){
          left = [1,2,3,4,5,6,"…",total]
        }else
        if(pageNo>(total-4)){
          left = [1,'…',total-4,total-3,total-2,total-1,total]
        }else{
          left = [1,'…',pageNo-2,pageNo-1,pageNo,pageNo+1,pageNo+2,'…',total]
        }
        left.forEach(item=>{
          page.push({name:item,active:item===pageNo||item=='…'})
        })
      }else{
        for(let a=0;a< total ; a++){
          page.push({name:a+1,active:a===this.page.pageNo})
        }
      }

      return page
    }
  },
  methods: {
    pagechange(e){
      let n = e.target.innerText;
      if(n=='Previous Page'){
        if(this.page.pageNo>0)
        this.page.pageNo--
        else
        return false
      }else if(n == 'Next Page'){
        if(this.page.pageNo<(this.paignation.length-1))
        this.page.pageNo++
        else
        return false;
      }else{
        this.page.pageNo = Number(n)-1
      }
      this.$emit('pageChange',this.page.pageNo)
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/template/pagiation.vue